var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalconyAndPatio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6445 24.9229C40.071 25.9367 40.0656 25.9421 38.5001 26.1895V26.6297C38.5001 29.0812 38.5001 31.5318 38.5001 33.9815C38.5001 34.9572 38.049 35.5905 37.2255 35.778C37.0344 35.8113 36.8403 35.8241 36.6466 35.8161H4.7907C3.58942 35.8161 2.95072 35.1855 2.948 33.9679C2.948 31.5219 2.948 29.0948 2.948 26.6569V26.1759C2.65991 26.146 2.40443 26.1297 2.15167 26.0943C1.76187 26.0312 1.40888 25.827 1.15991 25.5205C0.910936 25.214 0.783374 24.8266 0.801502 24.4322C0.819631 24.0377 0.982184 23.6637 1.25822 23.3813C1.53425 23.0989 1.90449 22.9279 2.29844 22.9009C2.46423 22.9009 2.63273 22.9009 2.80124 22.9009C14.7598 22.9009 26.7183 22.8963 38.6768 22.8873C39.6552 22.8873 40.3075 23.2297 40.6581 24.1538L40.6445 24.9229ZM9.38114 32.5574V26.1677H6.22029V32.5574H9.38114ZM15.8469 32.5574V26.1623H12.6806V32.5574H15.8469ZM19.1409 26.1731V32.5438H22.3099V26.1623L19.1409 26.1731ZM28.7757 26.1731H25.6012V32.5411H28.7757V26.1731ZM32.067 26.1731V32.5465H35.236V26.1623L32.067 26.1731Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0811 19.6557H10.24V12.6682H19.0811V19.6557Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3669 12.6627H31.2054V19.6503H22.3669V12.6627Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0948 0.818359V9.41218H10.3977C10.9521 5.44141 14.3359 1.53587 19.0948 0.818359Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0477 9.42032H22.3506V0.84552C26.4844 1.32386 30.4226 4.9549 31.0477 9.42032Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalconyAndPatio);
export default __webpack_public_path__ + "static/media/balcony-and-patio.b63e32f80908ffe4e9d9cf22057274bd.svg";
export { ForwardRef as ReactComponent };